<script setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import _ from "lodash";
import { useRouter } from "vue-router";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import adminUserService from "../../../services/user/adminUserService";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import { useAlertStore } from "../../../../../stores/alertStore";

const { $alert, $confirm } = useAlertStore();

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
});

const user = computed(() => props.user || {});

const router = useRouter()
const loadingStore = usePageLoadingStore()
const { $interests, $corpState, $ojfStateGb, $adminJoinStateGb, $gbNameKR, $toast, $number, $pageListBoardNo, $yyyymmddHHmmss, $yyyymmdd, $yyyymm, $gb, $bizNum, $userGbKR } = getCurrentInstance().appContext.config.globalProperties;

const interests = ref($interests);
const corpState = ref($corpState);
const ojfStateGb = ref($ojfStateGb);              // 진행 상태 - 특별채용관 참가 현황 tab
const adminJoinStateGb = ref($adminJoinStateGb);  // 참가 상태 - 특별채용관 참가 현황 tab

const openYnListRef = ref(null);            // 공개 상태
const ojfStateGbListRef = ref(null);        // 진행 상태
const adminJoinStateGbsListRef = ref(null); // 참가 상태

const jobFairUserList = ref([]);

const searchOpen = ref(true);

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);

const searchInput5 = ref({ // 특별채용관 참가 현황 tab 검색조건
  openYnList: ["Y", "N"], //공개 상태
  ojfStateGbList: ["00", "01", "02", "03", "04"], // (행사) 진행 상태
  joinStateGbsList: ['01', '02', '03', '04', '11', '21'], // (행사) 참가 상태
  searchOjfName: '',
});

const GroupOpenYn = ref([
  { label: "공개", value: "Y" },
  { label: "비공개", value: "N" }
]);

// 검색조건 - 페이지 크기
const pageSizeGroup = ref([
  { label:'10개씩 보기', value: '10' },
  { label:'30개씩 보기', value: '30' },
  { label:'50개씩 보기', value: '50' },
  { label:'100개씩 보기', value: '100' },
]);

// 1-1. 특별채용관 참가 현황 리스트 조회 - 학생/취업준비생
const retrieveAllEntryUserPaging = async () => {
  let paramObj = {
    userId: user.value.userId,
    searchOpenYn: _.map(searchInput5.value.openYnList).join(','),
    searchOjfStateGb: _.map(searchInput5.value.ojfStateGbList).join(','),
    searchJoinStateGb: _.map(searchInput5.value.joinStateGbsList).join(','),
    searchOjfName: searchInput5.value.searchOjfName,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  loadingStore.loading = true;
  //loaded.value = false;
  adminUserService.retrieveAllEntryUserPaging(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        //loaded.value = true;
        //console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          jobFairUserList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    loadingStore.loading = false;
    //loaded.value = true;
  });
}

// 1-2. 특별채용관 참가 현황 리스트 조회 - 재직자/기업
const retrieveAllRecruitmentHallByUserIdPaging = async () => {
  let paramObj = {
    userId: user.value.userId,
    searchOpenYn: _.map(searchInput5.value.openYnList).join(','),
    searchOjfStateGb: _.map(searchInput5.value.ojfStateGbList).join(','),
    searchJoinStateGb: _.map(searchInput5.value.joinStateGbsList).join(','),
    searchOjfName: searchInput5.value.searchOjfName,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  loadingStore.loading = true;
  //loaded.value = false;
  adminUserService.retrieveAllRecruitmentHallByUserIdPaging(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        //loaded.value = true;
        //console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          jobFairUserList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    loadingStore.loading = false;
    //loaded.value = true;
  });
}

// 페이지 선택
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  if(user.value.userGb === 'COMPANY') {
    retrieveAllRecruitmentHallByUserIdPaging();  // 재직자/기업
  } else {
    retrieveAllEntryUserPaging();  // 학생/취업준비생
  }
}

// 검색조건 - 페이지 크기 변경 이벤트
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  if(user.value.userGb === 'COMPANY') {
    retrieveAllRecruitmentHallByUserIdPaging();  // 재직자/기업
  } else {
    retrieveAllEntryUserPaging();  // 학생/취업준비생
  }
}

// 검색조건 - '초기화' 버튼
const clearSearchInput = () => {
  searchInput5.value = {
    openYnList: ["Y", "N"],
    ojfStateGbList: ["00", "01", "02", "03", "04"],
    joinStateGbsList: ['01', '02', '03', '04', '11', '21'],
    searchOjfName: ""
  };
  openYnListRef.value.initOptions();
  ojfStateGbListRef.value.initOptions();
  adminJoinStateGbsListRef.value.initOptions();
}

// 검색조건 - '검색' 버튼
const onClickSearch = () => {
  currentPage.value = 1;
  if(user.value.userGb === 'COMPANY') {
    retrieveAllRecruitmentHallByUserIdPaging();  // 재직자/기업
  } else {
    retrieveAllEntryUserPaging();  // 학생/취업준비생
  }
}

// 특별채용관 참가 현황 상세로 이동 - 학생/취업준비생
const goJobFairDetail = (ojfId, userId) => {
  router.push({ name: 'MemberJobFairDetail', query : { ojfId: ojfId, userId: userId }});
}

// 특별채용관 참가 현황 상세로 이동 - 재직자/기업
const goCorpJobFairDetail = (ojfId, corpId) => {
  router.push({ name: 'CorporationJobFairDetail', query : { ojfId: ojfId, corpId: corpId }});
}

onMounted(() => {
  if(user.value.userGb === 'COMPANY') {
    retrieveAllRecruitmentHallByUserIdPaging();  // 재직자/기업
  } else {
    retrieveAllEntryUserPaging();  // 학생/취업준비생
  }
})
</script>
<template>
  <!-- s: 검색 -->
  <div class="filter-wrap" :class="{'open': searchOpen}">
    <p @click="searchOpen = !searchOpen">검색</p>
    <div class="filter">
      <dl>
        <dt style="display:block;"><span>공개 상태</span><br /><small style="font-weight: normal;">복수 선택 가능</small></dt>
        <dd>
          <KSACheckBoxGroup
              ref="openYnListRef"
              className="mr-md"
              name="openYnList"
              v-model="searchInput5.openYnList"
              :options="GroupOpenYn" />
        </dd>
      </dl>
      <dl>
        <dt style="display:block;"><span>진행 상태</span><br /><small style="font-weight: normal;">복수 선택 가능</small></dt>
        <dd>
          <KSACheckBoxGroup
              ref="ojfStateGbListRef"
              className="mr-md"
              name="ojfStateGbList"
              v-model="searchInput5.ojfStateGbList"
              :options="ojfStateGb" />
        </dd>
      </dl>
      <dl>
        <dt style="display:block;"><span>참가 상태</span><br /><small style="font-weight: normal;">복수 선택 가능</small></dt>
        <dd>
          <KSACheckBoxGroup
              ref="adminJoinStateGbsListRef"
              className="mr-md"
              name="ojfStateGbList"
              v-model="searchInput5.joinStateGbsList"
              :options="adminJoinStateGb" />
        </dd>
      </dl>
      <!-- 행사명 검색 -->
      <dl>
        <dt>행사명</dt>
        <dd>
          <KSAInput class="text-box" v-model="searchInput5.searchOjfName" placeholder="행사명을 입력해 주세요." />
        </dd>
      </dl>
      <div class="btn-wrap">
        <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
        <KSAPrimaryButton text="검색" @click="onClickSearch" />
      </div>
    </div>
  </div>
  <!-- e: 검색 -->
  <div class="list-top">
    <p>전체 <span>{{ $number(totalCount)}}</span>건</p>
    <div>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
    </div>
  </div>
  <div class="table-form">
    <table class="horizontal" v-if="jobFairUserList !== null">
      <tr>
        <th>NO</th>
        <th>행사ID</th>
        <th>행사구분</th>
        <th>공개 상태</th>
        <th>진행 상태</th>
        <th>행사명</th>
        <th>접수기간</th>
        <th>행사기간</th>
        <th>참가 상태</th>
        <th>신청일</th>
      </tr>
      <tr v-for="ojf in jobFairUserList">
        <td>{{ ojf.boardNo }}</td>
        <td>{{ ojf.ojfId }}</td>
        <td>
          <span v-if="ojf.ojfGb === '01'">기업공채관</span>
          <span v-else>채용박람회</span>
        </td>
        <td>
          <span v-if="ojf.openYn === 'Y'">공개</span>
          <span v-else>비공개</span>
        </td>
        <td :class="ojf.ojfStateGb === '03' ? 'blue' : ojf.ojfStateGb === '05' ? 'red' : ojf.ojfStateGb === '04' ? 'gray' : ''">
          <!-- 상태가 '03'일 때 -->
          <span v-if="ojf.ojfStateGb === '03'" class="blue">
              {{ $gbNameKR("OJF_STATE_GB", ojf.ojfStateGb) }}
              {{ $isInRegPeriod(ojf.regStartYmd, ojf.regEndYmd) ? '(신청 접수중)' : ($isAfterRegEnd(ojf.regEndYmd) ? '(신청 마감)' : '') }}
          </span>
          <!-- 상태가 '03'이 아닐 때 -->
          <span v-else :class="ojf.ojfStateGb === '05' ? 'red' : ojf.ojfStateGb === '04' ? 'gray' : ''">
              {{ $gbNameKR("OJF_STATE_GB", ojf.ojfStateGb) }}
          </span>
        </td>
        <td v-if="user.userGb === 'COMPANY'" class="clickable blue" @click="goCorpJobFairDetail(ojf.ojfId, ojf.corpId)">{{ ojf.ojfName }}</td>
        <td v-else class="clickable blue" @click="goJobFairDetail(ojf.ojfId, user.userId)">{{ ojf.ojfName }}</td>
        <td>{{ $yyyymmdd(ojf.regStartYmd) }} ~ {{ $yyyymmdd(ojf.regEndYmd) }}</td>
        <td>{{ $yyyymmdd(ojf.ojfStartYmd) }} ~ {{ $yyyymmdd(ojf.ojfEndYmd) }}</td>
        <td :class="ojf.joinStateGb === '11' ? 'blue' : ojf.joinStateGb === '21' ? 'red' : ojf.joinStateGb === '03' || ojf.joinStateGb === '04' ? 'gray' : ''">
          {{ $gbNameKR("ADMIN_JOIN_STATE_GB", ojf.joinStateGb) }}
        </td>
        <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
      </tr>
    </table>
  </div>
  <div class="result-none" v-if="jobFairUserList.length === 0">
    참가 중인 행사가 없습니다.
  </div>
  <Paginate
      v-if="jobFairUserList.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
  />
</template>
<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.table-form {
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>